module.exports = __webpack_public_path__ + "img/sy.9c72cc14.svg";